// extracted by mini-css-extract-plugin
export default {"subscription_item_price":"PH","delete_item":"QH","subscription_item":"RH","subscription_item_img_wrapper":"SH","subscription_item_info":"TH","subscription_item_title":"UH","subscription_item_edit":"VH","subscription_item_wrapper":"WH","arrow":"XH","subscription_item_category":"YH","plus_button":"ZH","more_details":"aI","old_price":"bI","discount":"cI"};
    if(module.hot) {
      // 1737143662120
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  